<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="800" scrollable persistent>
      <v-card outlined>
        <v-card-title class="grey lighten-2">
          รายละเอียดเพิ่มเติม
          <v-spacer></v-spacer>
          <v-btn color="error" @click="$emit('closeDialog')" dark>
            {{ $t("consentform.close") }}
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap pa-1 justify-center>
            <v-flex xs11 lg11>
              <p class="pt-5">
                <b>{{ $t("consentlist.Cnumber") }} : </b>
                <v-icon
                  color="#077893"
                  style="cursor: pointer"
                  small
                  @click="Fn_CopyDetail(dataConsent.SendId)"
                  >mdi-file-multiple-outline</v-icon
                >
                {{ dataConsent.SendId }}
              </p>
              <v-card outlined>
                <v-card-text>
                  <!-- <p>
                    <b class="pb-2" style="font-size: 22px">
                      {{ $t("petition.text8") }}
                    </b>
                  </p> -->
                  <p>
                    <b>{{ $t("consentlist.NameShow") }} </b>
                    <span>{{ dataConsent.OwnerOneIDNameTh  || "-"  }}</span>
                  </p>
                  <p>
                    <b>{{ $t("consentlist.type") }} </b>
                    <span>
                      {{ dataConsent.Type  || "-"   }}
                    </span>
                  </p>
                  <p>
                    <b>{{ $t("petition.text20") }} </b>
                    <!-- <a v-on:click="Fn_DetailPolicy"
                      >{{ dataConsent.PolicyHeader }}
                    </a> -->
                    <span>{{ dataConsent.PolicyHeader || "-" }}</span>
                  </p>
                  <p>
                    <b>{{ $t("consentlist.ConsentName") }} </b>
                    <span>{{ dataConsent.ConsentName || "-" }}</span>
                  </p>
                  <p>
                    <b>{{ $t("consentlist.NameShow") }} </b>
                    <span>{{ dataConsent.OwnerInputNameTh || "-" }}</span>
                  </p>
                  <p>
                    <b>{{ $t("consentlist.Email") }} </b>
                    <span>{{ dataConsent.Email || "-" }}</span>
                  </p>
                  <p>
                    <b>{{ $t("petition.text12") }} </b>
                    <span>{{ dataConsent.SendAt }}</span>
                  </p>
                  <p>
                    <b>{{ $t("consentlist.Tag") }} </b>
                    <v-chip
                      small
                      style="border: 1px solid"
                      v-for="(item, i) in NewTag"
                      :key="i"
                      class="ma-1"
                      label
                      text-color="#077893"
                      color="#ddf7ff"
                    >
                      <b>{{ item }}</b>
                    </v-chip>
                  </p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <DialogGeneralConsent
      :show="DialogGeneral"
      :_detail="dataConsent"
      @closeDialogDelete="DialogGeneral = false"
    />
  </div>
</template>
<script>
import DialogGeneralConsent from "@/components/dialog/SearchConsentList/DialogSearchConsentDetail.vue";
export default {
  props: ["show", "dataConsent"],
  components: { DialogGeneralConsent },
  data: function () {
    return {
      DialogGeneral: false,
      NewTag: "",
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialog");
        }
      },
    },
  },
  watch: {
    shower(val) {
      if (val === true) {
        var newData = this.dataConsent.Tag;
        this.NewTag = newData.split(",").map((item) => item.trim());
      }
    },
  },
  methods: {
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
  },
};
</script>
